// extracted by mini-css-extract-plugin
export default {"brandColor":"#364d94","errorColor":"#e02424","infoColor":"#3f51b5"};